<div class="background">
  <div class="content">
    <div class="header">
      <span class="header-text">{{
        'COMPANY_COST_ADD.ADD_COMPANY_COST' | translate
      }}</span>
      <div class="form-control counter-mobile">
        <div class="input">
          <button (click)="changeCount(false)">-</button>
          <input
            focusSelect
            type="number"
            [(ngModel)]="count"
            (ngModelChange)="onInputChange($event)"
            (change)="checkRequirements()"
            [min]="1"
          />
          <button (click)="changeCount()">+</button>
        </div>
      </div>
    </div>
    <div class="form">
      <div
        class="file-section-mobile"
        [class.disabled]="count > 1 || isRecurring"
      >
        <div class="section-content">
          <div class="bills-clmn column">
            <div class="file-header">
              <input
                tabindex="0"
                hidden
                type="file"
                multiple
                accept=".pdf, .jpg, .jpeg, .heic, .png"
                #uploaderInvoice
                (change)="attachFiles($event, 'invoice')"
              />
              <div class="add-btn">
                <img
                  src="assets/plus-in-circle-purple.svg"
                  tabindex="0"
                  role="button"
                  enterPress="uploaderInvoice.click()"
                  (keydown.enter)="uploaderInvoice.click()"
                  (click)="uploaderInvoice.click()"
                  *ngIf="
                    files.invoiceFiles.length < 3 && count === 1 && !isRecurring
                  "
                />
              </div>
              <div class="label">
                {{ 'COMPANY_COST_ADD.BILLS' | translate }}
                {{ files.invoiceFiles.length }}/3
              </div>
            </div>
            <!-- <div class="take-a-photo" *ngIf="files.invoiceFiles.length < 3">
              <img
                src="assets/camera-plus.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderInvoice.click()"
                (keydown.enter)="uploaderInvoice.click()"
                (click)="uploaderInvoice.click()"
                *ngIf="
                  files.invoiceFiles.length < 3 && count === 1 && !isRecurring
                "
              />
              <label for="takePhotoInvoice" class="custom-button"
                >Take a Photo</label
              >
              <input
                id="takePhotoInvoice"
                type="file"
                accept="image/*"
                capture="environment"
                hidden
                (change)="onPhotoInvoice($event)"
              />
            </div> -->
            <div
              class="file"
              *ngFor="let invoiceFile of files.invoiceFiles; let i = index"
            >
              <img src="assets/document-icon-blue.svg" />
              <div class="label">
                {{ invoiceFile.name }}
              </div>
              <div class="delete-icon">
                <img
                  src="assets/cross-in-circle-red-small.svg"
                  tabindex="0"
                  role="button"
                  enterPress="removeFile(invoiceFile, 'invoice', i)"
                  (keydown.enter)="removeFile(invoiceFile, 'invoice', i)"
                  (click)="removeFile(invoiceFile, 'invoice', i)"
                  *ngIf="count === 1 && !isRecurring"
                />
              </div>
            </div>
          </div>
          <div class="payment-clmn column">
            <div class="file-header">
              <input
                hidden
                tabindex="0"
                type="file"
                multiple
                accept=".pdf, .jpg, .jpeg, .heic, .png"
                #uploaderPayment
                (change)="attachFiles($event, 'payment')"
              />
              <div class="add-btn">
                <img
                  src="assets/plus-in-circle-purple.svg"
                  tabindex="0"
                  role="button"
                  enterPress="uploaderPayment.click()"
                  (keydown.enter)="uploaderPayment.click()"
                  (click)="uploaderPayment.click()"
                  *ngIf="
                    files.paymentFiles.length < 3 && count === 1 && !isRecurring
                  "
                />
              </div>
              <div class="label">
                {{ 'COMPANY_COST_ADD.PAYMENT_STATEMENT' | translate }}
                {{ files.paymentFiles.length }}/3
              </div>
            </div>
            <!-- <div class="take-a-photo" *ngIf="files.paymentFiles.length < 3">
              <img
                src="assets/camera-plus.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderInvoice.click()"
                (keydown.enter)="uploaderInvoice.click()"
                (click)="uploaderInvoice.click()"
                *ngIf="
                  files.paymentFiles.length < 3 && count === 1 && !isRecurring
                "
              />
              <label for="takePhoto" class="custom-button">Take a Photo</label>
              <input
                id="takePhoto"
                type="file"
                accept="image/*"
                capture="environment"
                hidden
                (change)="onPhotoPayment($event)"
              />
            </div> -->
            <div
              class="file"
              *ngFor="let paymentFile of files.paymentFiles; let i = index"
            >
              <img src="assets/document-icon-blue.svg" />
              <div class="label">
                {{ paymentFile.name }}
              </div>
              <div class="delete-icon">
                <img
                  src="assets/cross-in-circle-red-small.svg"
                  tabindex="0"
                  role="button"
                  enterPress="removeFile(paymentFile, 'payment', i)"
                  (keydown.enter)="removeFile(paymentFile, 'payment', i)"
                  (click)="removeFile(paymentFile, 'payment', i)"
                  *ngIf="count === 1 && !isRecurring"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accounting">
        <div class="form-control">
          <div class="label">
            {{ 'COMPANY_COST_ADD.ACCOUNTING_CATEGORY' | translate }} *
          </div>
          <app-finance-dropdown
            class="gray-border"
            [width]="354"
            [values]="accountingCategoryOptions"
            [(value)]="companyCost.accountingCategory"
            (valueChange)="onCategorySelected($event)"
          ></app-finance-dropdown>
        </div>
        <div class="form-control">
          <div class="label" [class.disabled]="!companyCost.accountingCategory">
            {{ 'COMPANY_COST_ADD.SUBCATEGORY' | translate }} *
          </div>
          <app-finance-dropdown
            *ngIf="companyCost.accountingCategory"
            tabindex="companyCost.accountingCategory ? '':'-1'"
            class="gray-border"
            [width]="354"
            [values]="subcategoryOptions"
            [(value)]="companyCost.subcategory"
            (valueChange)="checkRequirements()"
          ></app-finance-dropdown>
          <input
            disabled
            autofocus="-1"
            class="disabled"
            *ngIf="!companyCost.accountingCategory"
          />
        </div>
        <div class="row">
          <div class="form-control">
            <div class="label">
              {{ 'COMPANY_COST_ADD.VENDOR_NAME' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
                >*</span
              >
            </div>
            <input
              focusSelect
              tabindex="0"
              type="text"
              [(ngModel)]="companyCost.name"
            />
          </div>
          <div class="form-control">
            <div class="label">
              {{ 'COMPANY_COST_ADD.DESCRIPTION' | translate }}
            </div>
            <input
              focusSelect
              type="text"
              [(ngModel)]="companyCost.description"
            />
          </div>
        </div>
        <div class="row">
          <div id="bill-date" class="form-control row-dates">
            <!-- {{(!files?.invoiceFiles?.length && !files?.paymentFiles?.length) ? '*' : ''}} -->
            <ops-calendar
              [label]="'COMPANY_COST_ADD.DATE_OF_BILL' | translate"
              (dateChanged)="onSelectDate($event, 'dateOfBill')"
              formName="companyCost.dateOfBill"
              [date]="companyCost.dateOfBill"
            />
          </div>
          <div id="payment-date" class="form-control row-dates">
            <ops-calendar
              [label]="'COMPANY_COST_ADD.PAYMENT_DATE' | translate"
              (dateChanged)="onSelectDate($event, 'paymentDate')"
              formName="companyCost.paymentDate"
              [date]="companyCost.paymentDate"
            />
          </div>
        </div>
        <div class="recurring">
          <div class="row">
            <div class="field">
              <div class="checkboxes">
                <div class="form-control">
                  <input
                    tabindex="0"
                    class="title-box clickable"
                    type="checkbox"
                    id="recurring"
                    name="recurring"
                    [(ngModel)]="isRecurring"
                    (change)="checkRequirements()"
                    [disabled]="count != 1"
                  />
                  <label for="recurring" class="clickable">{{
                    'COMPANY_COST_ADD.RECURRING' | translate
                  }}</label>
                </div>
              </div>
              <app-finance-dropdown
                *ngIf="isRecurring"
                class="gray-border"
                [values]="frequencyOptions"
                [(value)]="frequency"
                (valueChange)="onFrequencySelected($event)"
              ></app-finance-dropdown>
              <input tabindex="0" *ngIf="!isRecurring" />
            </div>
            <div
              id="end-date"
              class="form-control row-dates"
              [class.disabled]="!isRecurring"
            >
              <ops-calendar
                [label]="'COMPANY_COST_ADD.END_DATE' | translate"
                [isDisabled]="!isRecurring"
                (dateChanged)="onSelectEndDate($event)"
                [minDate]="companyCost.dateOfBill"
                [maxDate]="maxRecurringDate"
                formName="endDate"
                [date]="endDate"
              ></ops-calendar>
            </div>
          </div>
        </div>
      </div>

      <div class="cost-type custom-block">
        <div class="form-control counter">
          <div class="input">
            <button (click)="changeCount(false)">-</button>
            <input
              focusSelect
              type="number"
              [(ngModel)]="count"
              (ngModelChange)="onInputChange($event)"
              (change)="checkRequirements()"
              [min]="1"
            />
            <button (click)="changeCount()">+</button>
          </div>
        </div>
        <div class="form-control">
          <div class="label">
            {{ 'COMPANY_COST_ADD.COST_TYPE' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <app-finance-dropdown
            [width]="182"
            class="gray-border"
            [values]="costTypeOptions"
            [(value)]="companyCost.costType"
          ></app-finance-dropdown>
        </div>
        <div class="form-control">
          <div class="label">
            {{ 'COMPANY_COST_ADD.METHOD_OF_PAYMENT' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <app-finance-dropdown
            [width]="182"
            class="gray-border"
            [values]="paymentMethodOptions"
            [(value)]="companyCost.paymentMethod"
            (valueChange)="onSelectPaymentMethod($event)"
          ></app-finance-dropdown>
        </div>
        <div
          class="form-control"
          [class.disabled]="
            !companyCost.paymentMethod
          "
        >
        <!-- || paidByOptions?.length === 0 -->
          <div class="label">
            {{ 'COMPANY_COST_ADD.PAID_BY' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <!-- || paidByOptions?.length === 0 -->
          <app-finance-dropdown
            [width]="182"
            class="gray-border"
            [isDisabled]="
              !!!companyCost.paymentMethod
            "
            [values]="paidByOptions"
            [ignoreSort]="'true'"
            [showAddNewOption]="addNewOptionType !== null"
            [addNewOptionType]="addNewOptionType"
            [(value)]="companyCost.paidBy"
            (valueChange)="setPaidBy($event)"
            (addNewBankAccount)="onAddNewBankAccount()"
            (addNewCreditCard)="onAddNewCreditCard()"
          ></app-finance-dropdown>
        </div>
        <div class="form-control">
          <div class="label">
            {{ 'COMPANY_COST_ADD.COST_STATUS' | translate }}
            <span
              *ngIf="
                !files?.invoiceFiles?.length && !files?.paymentFiles?.length
              "
              >*</span
            >
          </div>
          <app-finance-dropdown
            [width]="182"
            class="gray-border"
            [values]="statusOptions"
            [(value)]="companyCost.status"
            (valueChange)="checkRequirements()"
          ></app-finance-dropdown>
        </div>
      </div>

      <div class="cost custom-currency-block">
        <div class="cost-row">
          <div class="form-control currency">
            <div class="label">
              {{ 'COMPANY_COST_ADD.CURRENCY' | translate }}
            </div>
            <app-finance-dropdown
              class="gray-border"
              [width]="84"
              [values]="currencyOptions"
              [ignoreSort]="'true'"
              [(value)]="companyCost.currencyCode"
              (valueChange)="onSelectCurrency($event)"
            ></app-finance-dropdown>
          </div>
          <div class="form-control amount">
            <div class="label">
              {{ 'COMPANY_COST_ADD.COST' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
                >*</span
              >
            </div>
            <input
              tabindex="0"
              [value]="expectedAmount"
              (change)="(expectedAmount)"
              opsNumber
              (keyup)="onEditCost($event)"
            />
          </div>
          <div class="field tax">
            <div class="checkboxes">
              <div class="form-control">
                <input
                  class="title-box clickable"
                  type="checkbox"
                  id="tax"
                  name="tax"
                  tabindex="0"
                  [(ngModel)]="isTaxed"
                  (click)="onToggleTax()"
                  (change)="checkRequirements()"
                />
                <label for="tax" class="clickable">{{
                  'COMPANY_COST_ADD.TAX' | translate
                }}</label>
              </div>
            </div>
            <div class="tax-input" [class.disabled]="!isTaxed">
              <input
                tabindex="0"
                [disabled]="!isTaxed"
                value="{{ taxPercentage }}"
                (keyup)="onEditTax($event)"
                opsNumber
              />
              <span style="margin: auto 12px auto auto">%</span>
            </div>
          </div>
        </div>
        <div class="cost-row">
          <div class="form-control rate">
            <div class="label">
              {{ 'COMPANY_COST_ADD.EXCHANGE_RATE' | translate }}
              <span
                *ngIf="
                  !files?.invoiceFiles?.length && !files?.paymentFiles?.length
                "
              >
                *</span
              >
            </div>
            <div class="input-with-button">
              <ops-numeric-input
                class="exchange-rate-input"
                [value]="companyCost.exchangeRate ?? 0"
                [decimal]="4"
                (onValueChange)="onEditExchangeRate($event)"
              ></ops-numeric-input>
              <button
                class="reciprocal-btn"
                type="button"
                (click)="calculateReciprocal()"
                [disabled]="!companyCost?.exchangeRate || companyCost.exchangeRate === 0"
              >
                1/x
              </button>
            </div>
          </div>
          <div class="form-control amount">
            <div class="label">
              {{ 'COMPANY_COST_ADD.COST_INCL_TAX' | translate }}
            </div>
            <div class="value">
              {{ currencySymbol }}
              {{ expectedAmountWithTax | number : '.0-0' }}
            </div>
            <div class="value-converted" *ngIf="hasDifferentCurrency">
              {{ currencyExchangeSymbol }}
              {{ expectedAmountWithTaxExchange | number : '.0-0' }}
            </div>
          </div>
          <div class="form-control tax">
            <div class="label">
              {{ 'COMPANY_COST_ADD.TAX_AMOUNT' | translate }}
            </div>
            <div class="value">
              {{ currencySymbol }}
              {{ expectedTaxAmount | number : '.0-0' }}
            </div>
            <div class="value-converted" *ngIf="hasDifferentCurrency">
              {{ currencyExchangeSymbol }}
              {{ expectedTaxAmountExchange | number : '.0-0' }}
            </div>
          </div>
        </div>
      </div>

      <div class="cost-type assign-to">
        <div class="form-control">
          <div class="label">
            {{ 'COMPANY_COST_ADD.ASSIGN_TO' | translate }}
          </div>
          <app-finance-dropdown
            [width]="182"
            class="gray-border"
            [values]="assignToOptions"
            [(value)]="companyCost.assignedTo"
          ></app-finance-dropdown>
        </div>
        <div class="checkboxes">
          <div class="form-control">
            <input
              tabindex="0"
              class="clickable"
              type="checkbox"
              id="payment-reminder"
              name="payment-reminder"
              [(ngModel)]="companyCost.hasReminder"
            />
            <label class="clickable" for="payment-reminder">{{
              'COMPANY_COST_ADD.PAYMENT_REMINDER' | translate
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="file-section" [class.disabled]="count > 1 || isRecurring">
        <div class="section-content">
          <div class="bills-clmn column">
            <div class="file-header">
              <input
                tabindex="0"
                hidden
                type="file"
                multiple
                accept=".pdf, .jpg, .jpeg, .heic, .png"
                #uploaderInvoice
                (change)="attachFiles($event, 'invoice')"
              />
              <div class="add-btn">
                <img
                  src="assets/plus-in-circle-purple.svg"
                  tabindex="0"
                  role="button"
                  enterPress="uploaderInvoice.click()"
                  (keydown.enter)="uploaderInvoice.click()"
                  (click)="uploaderInvoice.click()"
                  *ngIf="
                    files.invoiceFiles.length < 3 && count === 1 && !isRecurring
                  "
                />
              </div>
              <div class="label">
                {{ 'COMPANY_COST_ADD.BILLS' | translate }}
                {{ files.invoiceFiles.length }}/3
              </div>
            </div>
            <!-- <div class="take-a-photo" *ngIf="files.invoiceFiles.length < 3">
              <img
                src="assets/camera-plus.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderInvoice.click()"
                (keydown.enter)="uploaderInvoice.click()"
                (click)="uploaderInvoice.click()"
                *ngIf="
                  files.invoiceFiles.length < 3 && count === 1 && !isRecurring
                "
              />
              <label for="takePhotoInvoice" class="custom-button"
                >Take a Photo</label
              >
              <input
                id="takePhotoInvoice"
                type="file"
                accept="image/*"
                capture="environment"
                hidden
                (change)="onPhotoInvoice($event)"
              />
            </div> -->
            <div
              class="file"
              *ngFor="let invoiceFile of files.invoiceFiles; let i = index"
            >
              <img src="assets/document-icon-blue.svg" />
              <div class="label">
                {{ invoiceFile.name }}
              </div>
              <div class="delete-icon">
                <img
                  src="assets/cross-in-circle-red-small.svg"
                  tabindex="0"
                  role="button"
                  enterPress="removeFile(invoiceFile, 'invoice', i)"
                  (keydown.enter)="removeFile(invoiceFile, 'invoice', i)"
                  (click)="removeFile(invoiceFile, 'invoice', i)"
                  *ngIf="count === 1 && !isRecurring"
                />
              </div>
            </div>
          </div>
          <div class="payment-clmn column">
            <div class="file-header">
              <input
                hidden
                tabindex="0"
                type="file"
                multiple
                accept=".pdf, .jpg, .jpeg, .heic, .png"
                #uploaderPayment
                (change)="attachFiles($event, 'payment')"
              />
              <div class="add-btn">
                <img
                  src="assets/plus-in-circle-purple.svg"
                  tabindex="0"
                  role="button"
                  enterPress="uploaderPayment.click()"
                  (keydown.enter)="uploaderPayment.click()"
                  (click)="uploaderPayment.click()"
                  *ngIf="
                    files.paymentFiles.length < 3 && count === 1 && !isRecurring
                  "
                />
              </div>
              <div class="label">
                {{ 'COMPANY_COST_ADD.PAYMENT_STATEMENT' | translate }}
                {{ files.paymentFiles.length }}/3
              </div>
            </div>
            <!-- <div class="take-a-photo" *ngIf="files.paymentFiles.length < 3">
              <img
                src="assets/camera-plus.svg"
                tabindex="0"
                role="button"
                enterPress="uploaderInvoice.click()"
                (keydown.enter)="uploaderInvoice.click()"
                (click)="uploaderInvoice.click()"
                *ngIf="
                  files.paymentFiles.length < 3 && count === 1 && !isRecurring
                "
              />
              <label for="takePhoto" class="custom-button">Take a Photo</label>
              <input
                id="takePhoto"
                type="file"
                accept="image/*"
                capture="environment"
                hidden
                (change)="onPhotoPayment($event)"
              />
            </div> -->
            <div
              class="file"
              *ngFor="let paymentFile of files.paymentFiles; let i = index"
            >
              <img src="assets/document-icon-blue.svg" />
              <div class="label">
                {{ paymentFile.name }}
              </div>
              <div class="delete-icon">
                <img
                  src="assets/cross-in-circle-red-small.svg"
                  tabindex="0"
                  role="button"
                  enterPress="removeFile(paymentFile, 'payment', i)"
                  (keydown.enter)="removeFile(paymentFile, 'payment', i)"
                  (click)="removeFile(paymentFile, 'payment', i)"
                  *ngIf="count === 1 && !isRecurring"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-section">
        <button
          class="cancel button"
          tabindex="0"
          role="button"
          enterPress="onCancel()"
          (keydown.enter)="onCancel()"
          (click)="onCancel()"
        >
          {{ 'COMPANY_COST_ADD.CANCEL' | translate }}
        </button>
        <button
          class="save button"
          [disabled]="!isValid"
          [class.disabled]="!isValid"
          tabindex="0"
          role="button"
          enterPress="onSave()"
          (keydown.enter)="onSave()"
          (click)="onSave()"
        >
          {{ 'COMPANY_COST_ADD.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal components for creating bank accounts and credit cards -->
<ops-bank-account-create-modal
  id="bank-account-create-modal"
  (bankAccountCreated)="onBankAccountCreated()"
></ops-bank-account-create-modal>

<ops-credit-card-create-modal
  id="credit-card-create-modal"
  (creditCardCreated)="onCreditCardCreated()"
></ops-credit-card-create-modal>

<ops-custom-currency-modal
  [isVisible]="showCustomCurrencyForm"
  [config]="customCurrencyConfig"
  (currencyAdded)="onCustomCurrencyAdded($event)"
  (modalClosed)="onCustomCurrencyModalClosed()"
></ops-custom-currency-modal>
